'use client'

import { type ComponentProps } from 'react'

import { AnchorTarget } from '@/components/common/AnchorTarget'

import { GalleryDisplayProvider } from './GalleryDisplayProvider/GalleryDisplayProvider'
import { GalleryGroupsProvider } from './GalleryGroupsProvider/GalleryGroupsProvider'
import { GalleryLayout, type GalleryLayoutProps } from './GalleryLayout/GalleryLayout'
import { GalleryPreloadProvider } from './GalleryPreloadProvider/GalleryPreloadProvider'

type Props = Partial<ComponentProps<typeof GalleryDisplayProvider>> &
  Partial<ComponentProps<typeof GalleryGroupsProvider>> &
  GalleryLayoutProps['galleryViewProps']

export const Gallery = (props: Props) => {
  const { openLinksInNewTab, ...rest } = props
  return (
    <GalleryDisplayProvider {...rest}>
      <GalleryPreloadProvider>
        <GalleryGroupsProvider recs={rest.recs}>
          <AnchorTarget id='gallery' isSticky />
          <GalleryLayout galleryViewProps={{ openLinksInNewTab }} />
        </GalleryGroupsProvider>
      </GalleryPreloadProvider>
    </GalleryDisplayProvider>
  )
}
